import { Injectable } from "@angular/core";
@Injectable()
export class UrlEndpoints {
    public equipmentListEndPoint = '/api/pdesc/simpleequipmentbean';
    public customerListEndPoint = '/api/customer/combinedcustomers';
    public siteListEndPoint = '/api/site/sitesgreaterthan';
    public contactListEndPoint = '/api/contact/contactsgreaterthan';
    public documentRequestTypeListEndPoint = '/api/document/getdocumentrequesttypes';
    public documentPostEndPoint = '/api/document/documentrequest/sync';
    public operatorListEndPoint = '/api/operator/getall';
    public operatorAndAPIKeyListEndPoint = '/api/operator/getoperatorandapikeys';
    public depotListEndPoint = '/api/depot/getall';
    public productTypeListEndPoint = '/api/product/getsimpleproducttypebean';
    public policyListEndPoint = '/api/policy/getall';
    public priceListEndPoint = '/api/pricelist/getall';
    public tenderListEndPoint = '/api/tender/getall';
    public returnListEndPoint = '/api/contract/getallfordepot/1';
    public getAllLiveContractsForDepotEndPoint = '/api/contract/getallfordepot/';
    public getAllLiveContractsForPlantEndPoint = '/api/contract/getallforplant/';
    public deptListEndPoint = '/api/dept/getall';
    public deptGroupListEndPoint = '/api/deptgroup/getall';
    public hireDeptListEndPoint = '/api/hiredept/getall';
    public hireDeptGroupListEndPoint = '/api/hiredeptgroup/getall';
    public engineerListEndPoint = '/api/serviceJob/engineer/getall';
    public serviceJobListEndPoint = '/api/serviceJob/getall/';
    public serviceJobListByWorkerEndPoint = '/api/serviceJob/worker/';
    public meterTypeListEndPoint = '/api/serviceJob/meterTypes/getall';
    public contactListByTstampEndPoint = '/api/contact/contactsgreaterthan/timestamp/';
    public returnListByTstampEndPoint = '/api/contract/getallfordepotgreaterthan/timestamp/';
    public equipmentListByTstampEndPoint = '/api/pdesc/simpleequipmentbean/timestamp/';
    public ProductTypeListByTstampEndPoint = '/api/product/getsimpleproducttypegroupbeangreaterthan/timestamp/';
    public ProductTypeListByTstampWithStockLevelsEndPoint = '/api/product/getsimpleproducttypegroupbeangreaterthanwithstocklevels/timestamp/';
    public sparesUsedInWsEndPoint = '/api/product/getsimpleworkshopproducttypebean/all/';
    public customerListByTstampEndPoint = '/api/customer/combinedcustomers/timestamp/';
    public haccessListByTstampEndPoint = '/api/pdesc/gethaccessbean/timestamp/';
    public saccessListByTstampEndPoint = '/api/pdesc/getsaccessbean/timestamp/';
    public siteListByTstampEndPoint = '/api/site/getsites/timestamp/';
    public photoBase64PostEndPoint = '/api/document/photo/upload';
    public queuedDocumentsForOperatorEndPoint = '/api/queueddocuments/getforoperator/';
    public queuedDocumentsUnassignedAndOperatorEndPoint = '/api/queueddocuments/getforunassignedandoperator/';
    public assignDocumentToOperator = '/api/queueddocuments/assigndocumenttooperator/';
    public unassignDocument = '/api/queueddocuments/unassigndocument/';
    public authenticationPostEndPoint = '/api/authentication/apikey';
    public customerLocationListEndPoint = '/api/customerlocation/getall';
    public timeclockingPostEndPoint = '/api/document/timeclocking/sync';
    public loggingPostEndPoint = '/ErrorLoggingService/api/services/logerror';
    public mobileApplicationConfigurationEndPoint = '/api/mobileapplicationconfiguration/getconfig';
    public wsJobProjectEndPoint = '/api/project/getallprojects';
    public orderListEndPoint = '/api/order/getallfordepot/';
    public orderListCustomerEndPoint = '/api/order/getallforcustomer/';
    public plantStatusListEndPoint = '/api/plantstatus/getall/';
    public jobStatusListEndPoint = '/api/wsjobstatus/getall/';
    public jobStatusUpdateEndPoint = '/api/serviceJob/jobstatusupdate/';
    public engineerSignatureUpdateEndPoint = '/api/serviceJob/engineersignatureupdate';
    public jobSingleStatusUpdateEndPoint = '/api/serviceJob/singlestatusupdate/';
    public jobEngineerUpdateEndPoint = '/api/serviceJob/jobengineerupdate/';
    public printListEndPoint = '/api/printservice/getall/';
    public wsJobTypeListEndPoint = '/api/wsjobtype/getall/';
    public jobTypeUpdateEndPoint = '/api/serviceJob/jobtypeupdate/';
    public jobTemplateEndPoint = '/api/wstasktemplate/getall/';
    public wsTasksEndPoint = '/api/wstasktemplate/gettasks/';
    public jobHistoryEndPoint = '/api/serviceJob/recentjobsforserviceditem/';
    public jobCertificateTextEndPoint = '/api/serviceJob/jobcertificatetext/getall/';
    public getCustSiteForPdescRegEndPoint = '/api/serviceJob/getcustomersiteforplant/';
    public testConnectionEndpoint = '/api/connection/test/';
    public hRatesEndpoint = '/api/hrates/getall';
    public documentBeanQueuePostEndPoint = '/api/document/documentbeanqueue/add';
    public documentBeanQueueCheckQueueStatusEndPoint = '/api/document/documentbeanqueue/check';
    public getLiveContractsForCustomerEndPoint = '/api/contract/getlivecontractsforcustomer/';
    public getPriceListDetailsEndPoint = '/api/pricelist/details/getall/timestamp/';
    public getWsJobTemplateToWsNamedMeterBeansEndPoint = '/api/wstasktemplate/getallnamedmeters/';
    public getCashAccountsEndPoint = '/api/cashaccount/getcashaccounts/';
    public getPaymentMethodsEndPoint = '/api/cashaccount/getpaymentmethods/';
    public getPTSerialBeansByTstampEndPoint = '/api/product/getptserialbeangreaterthan/timestamp/';
    public getAllLiveDetailLinesByTstampEndPoint = '/api/contract/getalllivedetaillinedtosgreaterthan/timestamp/';
    public getAllLiveDetailLinesByCustomerEndPoint = '/api/contract/getalllivedetaillinedtosbycustomer/';
    public getSystemConfigurationEndPoint = '/api/systemconfiguration/getconfig/';
    public postActionsByOperatorAndDayEndPoint = '/api/jpointaction/getactionsforphoneforoperator'; // Even being a post it'll fetch the actions
    public postActionEndPoint = '/api/jpointaction/create';
    public getAllActionsPrioritiesEndPoint = '/api/jpointaction/priority/getall';
    public getAllActionsTypeEndPoint = '/api/jpointaction/actiontype/getall';
    public getAllActionsTypeAndFrequencyEndPoint = '/api/jpointaction/actiontype/getfrequency';
    public postCalculateReantalLineEndPoint = '/api/document/calculaterentalline';
    public getOrdersForOperatorHealthCare = '/api/order/getalloperator/';
    public getAllBinLocations = '/api/product/getallbinlocations';
    public getDefaultBundleItems = '/api/product/getdefaultbundleitems';
    public postDocumentBeanQueueQueryEndPont = '/api/queueddocuments/getdocumentbeanqueuelistforoperator'; 
    public getcontractforlocationandcontractEndPoint = '/api/contract/getcontractforlocationandcontract/';

    // StockTake
    public getRegisterZoneStockTake = '/api/stocktake/registerzone/';
    public postSyncStockTake = '/api/stocktake/stockcount/sync';
    public getProductTypeBarcodeStockTake = '/api/product/getsimpleproducttypebarcodebeangreaterthan/timestamp/';



}
